export const nbEmployeeList = ['1-5', '6-20', '21-100', '101-500', '501-1000', '1000+'];

export const defaultSkillValue = {
  id: '',
  text: '',
  level: 3
};
